import { render, staticRenderFns } from "./CampaignStats.vue?vue&type=template&id=066b517c"
import script from "./CampaignStats.vue?vue&type=script&lang=js"
export * from "./CampaignStats.vue?vue&type=script&lang=js"
import style0 from "./CampaignStats.vue?vue&type=style&index=0&id=066b517c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports